import { SimpleAlert } from "../components/Alerts/Alerts";
import { FIELD_HAS_NO_VALUE_TO_COPY } from "../i18n/keysTranslations";
import { ALERT_ICON_TYPE_WARNING } from "./constants";

export const isEmptyValue = (value) => {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") return value === "";
  if (Array.isArray(value)) return value.every(isEmptyValue);
  if (typeof value === "object") {
    return Object.entries(value)
      .filter(([key]) => key !== "id")
      .every(([, nestedValue]) => isEmptyValue(nestedValue));
  }
  return false;
};

/**
 * Si el valor a copiar está vacío, muestra una alerta y devuelve true
 * para que quien llama corte la copia.
 */
export const alertIfEmptyCopyValue = ({ value, t }) => {
  if (!isEmptyValue(value)) return false;

  SimpleAlert({
    title: t(FIELD_HAS_NO_VALUE_TO_COPY),
    icon: ALERT_ICON_TYPE_WARNING,
  });
  return true;
};

/**
 * Copia un valor a otro campo, pero no hace nada si el valor origen está vacío
 * (undefined, null, "", [] o {}).
 */
export const setCopiedValue = ({ setValue, path, value }) => {
  if (isEmptyValue(value)) return;

  setValue(path, value, { shouldValidate: true, shouldDirty: true });
};
